import { DomainBase } from "./DomainBase";
export class CompanyType extends DomainBase {
    constructor() {
        super();
        this.Name = "";
    }
}